import React from 'react';
import DocumentVaultBlock from './DocumentVaultBlock';

const DocumentsKeyDates = () => {
  return <DocumentVaultBlock />;
};

export default DocumentsKeyDates;
